package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodyRegular
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_arrow_down
import inspection.composeapp.generated.resources.ic_arrow_up
import org.jetbrains.compose.resources.painterResource

@Composable
fun SectionContent(
    text: String,
    expanded: Boolean,
    withRadius: Boolean,
    modifier: Modifier = Modifier,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onClick: () -> Unit,
) {
    Row(
        modifier = modifier
            .padding(
                bottom = if (withRadius) dimension.spacing.space1 else dimension.spacing.space0
            )
            .fillMaxWidth()
            .background(
                color = color.surface.brand.primarySubtle.default,
                shape = RoundedCornerShape(
                    if (withRadius) dimension.radius.md else dimension.spacing.space0
                )
            )
            .clickable(onClick = onClick)
            .padding(dimension.spacing.space4),
        horizontalArrangement = Arrangement.spacedBy(dimension.spacing.space2),
    ) {
        Icon(
            painter = painterResource(if (expanded) Res.drawable.ic_arrow_up else Res.drawable.ic_arrow_down),
            tint = color.icon.subtle,
            contentDescription = text.trim()
        )

        TextBodyRegular(text = text.trim(), modifier = Modifier.weight(1f))
    }
}
